var rich_content_viewer_default = {
  "fontElementMap": "ttqW7",
  "wrapper": "hinLA",
  "pluginContainerMobile": "PfO9h",
  "viewer": "hce2w",
  "android": "Vr28M",
  "rootedTraversedContent": "foN2P",
  "atomic": "fw6zT",
  "toolbar": "_67BWr",
  "block": "END-d"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
